import React, { Fragment, useEffect, useRef, useState } from "react"
import propsTypes from "prop-types"
// @ts-ignore
import { CSVLink } from "react-csv"

export interface CsvData {
  data: string[][]
  headers: any
  filename: string
}

const CsvExport = ({
  asyncExportMethod,
  children,
  disable,
}: {
  asyncExportMethod: () => Promise<CsvData>
  children: any
  disable: boolean
}) => {
  const [csvData, setCsvData] = useState<CsvData | null>(null)
  const csvInstance = useRef()
  useEffect(() => {
    if (csvData && csvInstance.current && (csvInstance.current as any).link) {
      setTimeout(() => {
        ;(csvInstance.current as any).link.click()
        setCsvData(null)
      })
    }
  }, [csvData])
  return (
    <Fragment>
      <div
        className="csvDownloadButton"
        onClick={async () => {
          if (disable) {
            return
          }
          const newCsvData = await asyncExportMethod()
          setCsvData(newCsvData)
        }}
      >
        {children}
      </div>
      {csvData ? (
        <CSVLink
          data={csvData.data}
          headers={csvData.headers}
          filename={csvData.filename}
          ref={csvInstance}
        />
      ) : undefined}
    </Fragment>
  )
}

export default CsvExport

CsvExport.defaultProps = {
  children: undefined,
  asyncExportMethod: () => null,
  disable: false,
}

CsvExport.propTypes = {
  children: propsTypes.node,
  asyncExportMethod: propsTypes.func,
  disable: propsTypes.bool,
}
